import styled from 'styled-components'

import { helpers } from 'styles'

export const Row = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	flex-wrap: wrap;

	padding: 14px 0;
	min-height: 48px;
	gap: 8px 12px;

	border-bottom: 1px solid ${helpers.color.separator};
`
